import ImageFilter from '@/typings/ImageFilter';

const getFilterKey = (filter) => {
    try {
        const filterKey = Object.keys(ImageFilter).find((key) => ImageFilter[key] === filter);
        if (!filterKey) {
            throw new Error(`Invalid filter: ${filter}`);
        }
        return filterKey.toLowerCase();
    } catch (error) {
        console.error(error);
        return getFilterKey(ImageFilter.DEFAULT);
    }
};

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CustomilyImageFilterAPIService', CustomilyImageFilterAPIService);

    function CustomilyImageFilterAPIService() {
        const baseURL = `${process.env.VUE_APP_CUSTOMILY_IMAGE_FILTER_API_URL}`;

        async function applyFilter(image, filter = ImageFilter.DEFAULT) {
            const formData = new FormData();
            formData.append('imagefile', image);

            try {
                const response = await fetch(`${baseURL}/?filters=${getFilterKey(filter)}`, {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.blob();
            } catch (error) {
                throw error;
            }
        }

        return {
            applyFilter
        };
    }
})();
